module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#DE2925\" cx=\"8\" cy=\"8\" r=\"8\"></circle><path d=\"M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm4-4l-1 1-3-3-3 3-1-1 3-3-3-3 1-1 3 3 3-3 1 1-3 3 3 3z\" fill=\"#FFF\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/CargoPhotoList/del_photo_icon.svg
// module id = 1992
// module chunks = 0